import React from 'react';
import { Hero } from './components/Hero';
import { WhatIncludes } from './components/WhatIncludes';
import { PainValidation } from './components/PainValidation';
import { Solution } from './components/Solution';
import { HowItWorks } from './components/HowItWorks';
import { Features } from './components/Features';
import { Benefits } from './components/Benefits';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { FinalCTA } from './components/FinalCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Testimonials } from './components/Testimonials';
export function App() {
  return <div className="min-h-screen bg-[#fafaf9] font-sans text-stone-900" data-id="element-0" data-mp="2wiyuqllirh8i">
      <UrgencyBanner data-id="element-1" data-mp="28tw5arkn8k3g" />
      <Hero data-id="element-2" data-mp="28te37ebavbnm" />
      <WhatIncludes data-id="element-3" data-mp="28sutulzptvl7" />
      <PainValidation data-id="element-4" data-mp="28sb9kymlev40" />
      <Solution data-id="element-5" data-mp="23vkwmk634fmt" />
      <HowItWorks data-id="element-6" data-mp="23vulg4fe8gqx" />
      <Features data-id="element-7" data-mp="23ujksdh8vp41" />
      <Benefits data-id="element-8" data-mp="23ut9lxqjzq85" />
      <Bonuses data-id="element-9" data-mp="23t8ea5wf0398" />
      <Pricing data-id="element-10" data-mp="3ijxokogyjwiu" />
      <Testimonials data-id="element-11" data-mp="3ikha0f5th31m" />
      <FinalCTA data-id="element-12" data-mp="3iiwg8rrbto4t" />
      <SocialProofPopup data-id="element-13" data-mp="3ijfu9xduvsdk" />
    </div>;
}